import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';


@Component({
    selector: 'core-version-single-version-files-list-checkbox',
    templateUrl: './single-version-files-list-checkbox.component.html',
    styleUrls: ['./single-version-files-list-checkbox.component.scss']
})
export class VersionFilesSingleVersionFilesListCheckboxComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() version: Objects.Version;
    @Input() request:Objects.Request;
    @Input() disabled: boolean;
    @Input()  selected: Array<Objects.File>;
    @Output() selectedChange = new EventEmitter<Array<Objects.File>>();

    public status:number = this.LOADING;
    public versions: Array<Objects.Version> = [];
    public feedbacks: Array<VersionShareItem>;
    public groupLabels: Array<Objects.Label> = [];

    private feedbacksSubscription: Subscription;

    constructor(private httpClient: HttpClient, private urlSrv: UrlService, private versionSharesSrv: VersionSharesService ) { }

    ngOnInit() {
        this.loadFeedbacks(this.version);
        this.groupLabels = this.diffLabels(this.version.labels);
    }

    ngOnDestroy(): void {
        this.feedbacksSubscription?.unsubscribe();
    }

    onChange(files: Array<Objects.File>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    loadFeedbacks(version:Objects.Version) : void  {
        // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by VersionSharesService.getVersionShareItems$ (GET /versions/{vid}/shares for one version)
        // this.feedbacksSubscription = this.httpClient.get(this.urlSrv.build("/p/feedback/versions/feedbacks/"+version.id)).subscribe({
        this.feedbacksSubscription = this.versionSharesSrv.getVersionShareItems$([version]).subscribe({
            next: (data: Array<VersionShareItem>) => {
                this.feedbacks = data;
            },
            error: (err: any) => {
                console.log(err)
            }
        })

    }

    private diffLabels(labels: Array<Objects.Label>): Array<Objects.Label> {
        if(this.request != null)
            return labels.filter(vl => !this.request.labels.some(rl => vl.id == rl.id));
        return [];
    }

}
